module.exports = __webpack_public_path__ + "media/images/reportimages/clipboard-e783573420b4036108ec17200a192658.png";